import { render, staticRenderFns } from "./GoToCoordinatesControl.vue?vue&type=template&id=1ec94168"
import script from "./GoToCoordinatesControl.vue?vue&type=script&lang=js"
export * from "./GoToCoordinatesControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports